import React, { useState } from 'react';
import FullCard from '../../../../components/Card/FullCard';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import API from '../../../../api/axios';
import { useParams } from 'react-router-dom';

const Password = ({ showMessage }) => {
  const { id } = useParams();
  const [submiting, setSubmiting] = useState(false);
  const [password, setPassword] = useState('');
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmiting(true);
    try {
      const response = await API.put(
        `/api/v1/admin/user/changepassword/${id}`,
        {
          password,
        }
      );
      showMessage(1, '', '', 'گذرواژه تغییر یافت');
    } catch (error) {
      console.error(JSON.stringify(error, null, 2));
      showMessage(2, '', '', 'بروز خطا');
    }

    setSubmiting(false);
  };
  return (
    <FullCard
      title="تعیین رمز کاربر"
      category="این بخش جهت تغییر رمز کاربر استفاده میشود."
    >
      <form onSubmit={handleSubmit}>
        <Grid container direction="column" spacing={1}>
          <Grid item xs={4}>
            <TextField
              variant="outlined"
              color="primary"
              label="گذرواژه"
              type="password"
              fullWidth
              name="user_password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              size="large"
              onClick={handleSubmit}
              disabled={submiting}
            >
              تغییر گذرواژه
            </Button>
          </Grid>
        </Grid>
      </form>
    </FullCard>
  );
};

export default Password;
